import styled from 'styled-components';

const TeamStyle = styled.section`
	.ContactTeemCont {
		--autoSelectBg: var(--color2);
		--autoSelectColor: var(--color1);

		overflow: scroll;
		height: 100%;
		color: var(--color1);

		.page-top-section-container-wrap {
			.title {
				text-align: right;
			}

			.item-1,
			.item-2,
			.item-3 {
				display: block;
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
			.titleWrap {
				.title {
					max-width: var(--sp30x) !important;
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			--sectionTitleMaxWidth: 35%;
			--sectionInfoMaxWidth: 54%;
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
			--sectionTitleMaxWidth: 25%;
			--sectionInfoMaxWidth: 64%;
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
			--contPadLeft: 13%;
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
			--sectionTitleMaxWidth: 25%;
			--sectionInfoMaxWidth: 61%;
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
			--sectionTitleMaxWidth: 25%;
			--sectionInfoMaxWidth: 59%;
			--contPadLeft: 20%;
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
			--sectionTitleMaxWidth: 20%;
			--sectionInfoMaxWidth: 60%;
			--contPadLeft: 18%;
		}
	}
`;

export default TeamStyle;
